import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import { Analytics } from '@lifesize/web-clients-core';
import VbbSettings from 'components/VbbSettings/VbbSettings'
import JoinButtons from 'containers/JoinModal/JoinButtons/JoinButtons';
import AvSettings from 'components/AvSettings/AvSettings';
import Tooltip from 'components/Tooltip/Tooltip';
import { TrackEvents } from 'utils/analytics';
import classes from './JoinModal.module.scss';

export class JoinModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVbbSettings: false
    };
  }

  componentDidMount() {
    Analytics.track(TrackEvents.JoinModal, { isGuest: this.props.isGuest });
  }

  onToggleVbbSettings = () => {
    this.setState({ showVbbSettings: !this.state.showVbbSettings });
  }

  titleGenerator = () => {
    const contactName = this.props.remoteContact.name || this.props.remoteContact.displayName || '';

    if (this.props.isGuest) {
      return (
        <header className={`${classes.titleWithName} ${classes.guestTitle}`}>
          <h1 className={classes.joiningName}>
            {this.props.userName ?
              <FormattedMessage
                id="components.joinModal.joiningName"
                defaultMessage="Welcome, {userName}!"
                values={{
                  userName: this.props.userName
                }}
              /> :
              <FormattedMessage
                id="components.joinModal.joiningNoName"
                defaultMessage="Welcome"
              />
            }
          </h1>
          <h3 className={classes.joinSubtitle}>
            <FormattedMessage
              id="components.joinModal.joinSubtitle"
              defaultMessage="Select your video and audio options to get started."
            />
          </h3>
        </header>
      );
    }

    return (
      <header className={classes.titleWithName}>
        {contactName.length > 32 && <Tooltip label={contactName} className={classes.wrapTooltip} />}
        <h2 className={classes.joiningText}>
          <FormattedMessage
            id="components.joinModal.joining"
            defaultMessage="Joining"
          />
        </h2>
        <h1 className={classes.joinTitle}>
          {contactName}
        </h1>
      </header>
    );
  };

  render() {
    const modalClasses = _compact([
      classes.joinModal,
      this.props.fullScreen ? classes.fullScreen : '',
      !this.props.isGuest ? classes.loggedInFlow : ''
    ]).join(' ');

    const buttonClasses = _compact([
      classes.buttonSection,
      this.props.fullScreen ? classes.fullScreenButtons : ''
    ]).join(' ');

    return (
      <div className={modalClasses}>
        {(this.props.vbbFeatureEnabled && this.state.showVbbSettings) ? (
          <VbbSettings isJoinFlowCall={true} onToggleVbbSettings={this.onToggleVbbSettings} />
        ) : (
          <>
            {this.titleGenerator()}
            <AvSettings
              isJoinFlowCall={true}
              onToggleVbbSettings={this.onToggleVbbSettings}
              extension={this.props.extension}
            />
          </>
        )}
        <section className={buttonClasses}>
          <JoinButtons
            extension={this.props.extension}
          />
        </section>
      </div>
    );
  }
}

JoinModal.propTypes = {
  children: PT.element,
  extension: PT.string,
  fullScreen: PT.bool,
  isGuest: PT.bool,
  remoteContact: PT.object,
  userName: PT.string,
  vbbFeatureEnabled: PT.bool
};

export default JoinModal;
